/*
 * MN — "Elegir talla": no preseleccionar ninguna talla.
 *
 * EL PROBLEMA
 * -----------
 * Dawn siempre deja marcada la primera variante disponible. En una tienda de
 * ropa eso significa que la S aparece elegida de fábrica, y quien no se fije
 * puede comprar una talla que no quería. Carhartt —la referencia— no
 * preselecciona: hasta que no eliges, el botón pone "Elegir talla" y no deja
 * añadir al carrito.
 *
 * POR QUÉ NO SE DESMARCAN LOS RADIOS
 * ----------------------------------
 * Lo evidente sería desmarcar todos los `input[type=radio]` al cargar. No se
 * hace, y es deliberado: Dawn calcula precio, disponibilidad, imagen y la URL
 * `?variant=` a partir de cuál está marcado. Sin ninguno marcado, su
 * `variant-selects` se queda sin variante y la ficha se rompe de formas poco
 * obvias — el precio desaparece, el formulario no sabe qué enviar.
 *
 * Así que la selección interna de Dawn se deja intacta y lo que se hace es
 * poner una PUERTA delante:
 *
 *   - una clase en la sección hace que la talla marcada no PAREZCA marcada,
 *   - el botón de comprar se deshabilita y pasa a poner "Elegir talla",
 *   - los botones de pago rápido (PayPal) se ocultan, o se podría pagar
 *     saltándose la puerta.
 *
 * Al primer clic sobre cualquier talla, la puerta se abre y todo vuelve a la
 * normalidad. A partir de ahí Dawn manda como siempre.
 *
 * CUÁNDO NO SE APLICA
 * -------------------
 * - Si la URL ya trae `?variant=`, porque entonces la persona viene de un
 *   enlace a una talla concreta y ya ha elegido.
 * - Si el producto tiene una sola opción posible: no hay nada que elegir.
 *
 * La barra inferior de compra no necesita saber nada de todo esto: copia el
 * estado y la etiqueta del botón real, así que se deshabilita y pone "Elegir
 * talla" ella sola.
 */

(function () {
  function gate(scope) {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    const submit = scope.querySelector('.product-form__submit');
    const radios = scope.querySelectorAll('.product-form__input input[type="radio"]');
    if (!submit || radios.length < 2) return;

    const label = scope.dataset.mnChooseLabel;
    const span = submit.querySelector('span');
    if (!label || !span) return;

    const originalLabel = span.textContent;
    const originalDisabled = submit.disabled;

    scope.classList.add('mn-size-unchosen');
    submit.disabled = true;
    span.textContent = label;

    const open = () => {
      scope.classList.remove('mn-size-unchosen');
      submit.disabled = originalDisabled;
      span.textContent = originalLabel;
      scope.removeEventListener('click', onPick);
      scope.removeEventListener('change', onPick);
    };

    /* Se escucha `click` además de `change` a propósito. Si alguien pulsa
       justamente la talla que Dawn dejó marcada por dentro, el radio ya está
       marcado y `change` NO se dispara: sin el `click` la puerta no se abriría
       nunca para esa talla. */
    const onPick = (event) => {
      if (event.target.closest('.product-form__input')) open();
    };

    scope.addEventListener('click', onPick);
    scope.addEventListener('change', onPick);
  }

  function init() {
    document.querySelectorAll('product-info[data-mn-choose-label]').forEach(gate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
